<template>
    <div :class="field.classes">
        <label class="checkbox-label with-flexible-parts mt-0" >
            <input
                class="checkbox flexible-part" type="checkbox"
                :name="field.name"  
                :id="field.name"
                :value="value"
                @change="update"
                :class="inputClass"
                >        
            <div class="checkbox-box lw-brand-border flexible-part">
                <span class="learnworlds-icon learnworlds-heading3-small fas fa-check"></span>
            </div>
            <div class="flexible-part">
                <div class="learnworlds-main-text  learnworlds-main-text-small learnworlds-element">
                    {{ name }}
                </div>
            </div>
        </label>
        <div v-if="error" class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text">
        {{ error }}
        </div>
    </div>
</template>

<script>
    import FieldMixin from "./FieldMixin";

    export default {
        name: "CheckboxComponent",

        mixins: [
            FieldMixin
        ],
        methods: {
            update(e) {            
                this.$emit('input', event.target.checked);
            }, 
        }
    }
</script>
